import React from "react";
import {
  getGenericInputStylesCP,
  getGenericInputStylesContainerTelcel,
  applyFocusStyles,
} from "../../../styles/genericInput";
import './index.css'

class GenericInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  handleFocus = (e) => {
    const { hasError } = this.props;
    applyFocusStyles(e.target, hasError);
  };

  handleBlur = (e) => {
    const { hasError } = this.props;
    e.target.style.border = hasError ? "1px solid #D32222" : "1px solid #757575";
  };

  render() {
    const { isContainerTelcel, imgInputIcon, showIcon, hasError } = this.props;

    const stylesValues = isContainerTelcel
      ? getGenericInputStylesContainerTelcel(imgInputIcon, showIcon, hasError)
      : getGenericInputStylesCP(imgInputIcon, showIcon);
    const { input } = stylesValues;

    const { inputInfo, handleOnChangeInput, value, handleOnClickInput } =
      this.props;
    const { pattern, inputMode, type, id, name, placeHolder, min, max, onlyRead } =
      inputInfo;
    return (
      <input
        pattern={pattern}
        inputMode={inputMode}
        type={type}
        id={id}
        name={name}
        required
        style={input}
        value={value}
        onChange={(e) => handleOnChangeInput(e, id)}
        onClick={(e) => handleOnClickInput(e, id)}
        placeholder={placeHolder}
        min={min}
        max={max}
        readOnly={onlyRead}
        onFocus={isContainerTelcel ? this.handleFocus : null}
        onBlur={isContainerTelcel ? this.handleBlur : null}
      />
    );
  }
}
export default GenericInput;
